<div class="container">
    <div class="p-fluid p-formgrid p-grid">
            <ng-content select="[principal]" class="container-grid"></ng-content>
        </div>
        <div class="p-fluid p-formgrid p-grid">
            <ng-content select="[secundario]" class="container-grid-2"></ng-content>
        </div>
</div>